import React from 'react';
import { useTranslation } from 'react-i18next';

import { Printer } from '../../services/types';

interface PrinterSelectorProps {
  printers: Printer[];
  selectedPrinterId: string | null;
  onChange: (printerId: string) => void;
  isLoading?: boolean;
  error?: string | null;
}

export const PrinterSelector: React.FC<PrinterSelectorProps> = ({
  printers,
  selectedPrinterId,
  onChange,
  isLoading,
  error,
}) => {
  const { t } = useTranslation();
  const enabled = printers.filter((p) => p.enabled && p.kind === 'label');

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {t('labelPrinting.selectPrinter', { defaultValue: 'Printer' })}
      </label>
      {isLoading ? (
        <div className="text-sm text-gray-500">
          {t('labelPrinting.loadingPrinters', {
            defaultValue: 'Loading printers...',
          })}
        </div>
      ) : enabled.length === 0 ? (
        <div className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-md p-3">
          {t('labelPrinting.noPrinters', {
            defaultValue:
              'No printers configured. Ask an admin to add one in the Admin console.',
          })}
        </div>
      ) : (
        <select
          value={selectedPrinterId || ''}
          onChange={(e) => onChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
        >
          {!selectedPrinterId && (
            <option value="" disabled>
              {t('labelPrinting.selectPrinterPlaceholder', {
                defaultValue: 'Select a printer',
              })}
            </option>
          )}
          {enabled.map((printer) => (
            <option key={printer.printerId} value={printer.printerId}>
              {printer.name} ({printer.ip}:{printer.port})
            </option>
          ))}
        </select>
      )}
      {error && <p className="mt-2 text-xs text-red-600">{error}</p>}
    </div>
  );
};
